{
    "MainTitleAdd": "Adicionar ambiente de gerenciamento central",
    "MainTitleModify": "Modificar o ambiente de gerenciamento central",
    "DomainsTitle": "Perfil do domínio",
    "ProvisioningTitle": "Provisionamento",
    "EstateTitle": "Estado",
    "UnknownDescription": "[Descrição desconhecida]",
    "LanguageCME_ButtonHelpLabel": "Ajuda?",
    "LanguageCME_ButtonSubmitLabel": "OK",
    "LanguageCME_ButtonCancelLabel": "Cancelar",
    "LanguageCME_PromptMessage": "Tem certeza de que deseja fechar esta janela? Todas as configurações modificadas serão perdidas quando fechadas.",
    "LanguageCME_PromptConfirm": "sim",
    "LanguageCME_PromptCancel": "Cancelar",
    "LanguageCME_DetailsTitle": "Detalhes do CME",
    "NAME": "LanguageCME",
    "LicenseManagementTitle": "Gerenciamento de Licenças",
    "CME_AdvancedTabTitle": "Avançado",
    "CME_Fields_RecursiveRealTimeBots": "Ativar\/desativar o tempo real para todos os servidores Tel",
    "CME_EnableVoiceAppBots": "Iniciar filas de espera em tempo real para {} Servidores Tel",
    "CME_EnableVoiceAppBots_Recursive": "Iniciar filas de espera em tempo real para todos os servidores Tel",
    "CME_DisableVoiceAppBots": "Parar filas de espera em tempo real para {} Servidores Tel",
    "CME_DisableVoiceAppBots_Recursive": "Parar as filas de espera em tempo real para todos os servidores Tel",
    "CME_EnableVoiceAppBots_Confirmation_Title": "Informamos que o acionamento desta opção pode levar à deterioração da funcionalidade do inquilino. Esta opção só deve ser utilizada depois de consultar a nossa equipa de apoio.",
    "CapabilitiesTitle": "Capacidades",
    "BrandingTitle": "Marca"
}